import { ModelHTML2PDF } from "./ModelHTML2PDF"
import { HTMLController } from "./../../classes/mvc/HTML/HTMLController";
import Handlebars = require( "handlebars" );



export class ControllerHTML2PDF extends HTMLController<ModelHTML2PDF>{
    private templatename:string="";
    private template_handlebar="";
    private document_papersize:string="";
    private outputContainer: JQuery<HTMLElement>;

    public constructor(accessName: string, accessID: number, outputContainer:JQuery<HTMLElement>) {
        super(new ModelHTML2PDF(), accessName, accessID,outputContainer);

        this.outputContainer = outputContainer;
    }

    public initGlobals(): void {
        // Load YAML configuration
         this.document_papersize = this.getModule().getConfig("paper_size");
         this.template_handlebar = this.getModule().getConfig("handlebar");
        // Load HTML-Element Data-Attribute Configuration
        this.templatename = this.getParam( "template" );
    }

    public run(): void {

        let labelName=this.getModule().getLabel("lable_name");
        let handleBars= Handlebars.compile( this.template_handlebar );
        let handleBarObject={
            lable_name:labelName,
            document_papersize: this.document_papersize
        }
        
        var result:string = handleBars(handleBarObject);
        console.log("Modul HTML2PDF gestartet!");
        this.outputContainer.html(result)
    }
}